<template>
  <div>
    <vue-list-picker
      :left-items="cultures"
      :content-key="'id'"
      :content-attr="'description'"
      :title-left="'CULTURAS'"
      :title-right="product.description"
      :content-class="'itensGrupos'"
      :title-class="'tituloGrupos'"
      :button-class="'btn btn-success button-class'"
      :right-items="rightItems"
      v-on:move-right="addCultureToProduct(product.id, $event)"
      v-on:move-left="removeProductCulture(product.id, $event)"
      v-on:move-all-right="addCultureToProduct(product.id, $event)"
      v-on:move-all-left="removeProductCulture(product.id, $event)"
      :left-search="true"
      v-on:search-action-left="searchEventLeft"
      :right-search="true"
      v-on:search-action-right="searchEventRight"
      />
  </div>
</template>

<script>

import VueListPicker from "@/components/Vue-list-picker/VueListPicker";

export default {
  components: {
    VueListPicker
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    },
    cultures: {
      type: Array,
      default: () => []
    },
    rightItems: {
      type: Array,
      default: () => []
    },
    allRightCultures: {
      type: Array,
      default: () => []
    },
    productCultures: {
      type: Object,
      default: () => ({
        id: null,
        culture_ids: []
      })
    }
  },
  methods: {
    searchEventLeft(search) {
      this.$emit('search-action-left', search);
    },
    searchEventRight(search) {
      this.$emit('search-action-right', search);
    },
    clearProductData() {
      this.productCultures.culture_ids = [];
      this.productCultures.id = null;
    },
    addCultureToProduct(product_id, cultures) {
      this.productCultures.id = product_id;

      if (Array.isArray(cultures)) {
        cultures.forEach(culture => {
          if (!this.productCultures.culture_ids.includes(culture.id)) {
            this.productCultures.culture_ids.push(culture.id);
            this.allRightCultures = [culture, ...this.allRightCultures.filter(item => item.id !== culture.id)];
          }
        });
      } else if (cultures && typeof cultures.id !== 'undefined') {
        if (!this.productCultures.culture_ids.includes(cultures.id)) {
          this.productCultures.culture_ids.push(cultures.id);
          this.allRightCultures = [cultures, ...this.allRightCultures.filter(item => item.id !== cultures.id)];
        }
      }

      this.productCultures.culture_ids = [...new Set(this.productCultures.culture_ids)];

      this.$emit('update-cultures', this.allRightCultures);
    },
    saveCultureToProduct() {
      this.$http.secured
        .put(`/api/v1/products/${this.productCultures.id}`, { product: { culture_ids: this.productCultures.culture_ids }})
        .then(response => {
          this.response = response.data;
          this.productCultures.culture_ids = [];
          this.productCultures.id = null
          this.$toasted.global.defaultSuccess();
          this.$emit('cultures-saved');
        })
        .catch(error => 
          this.setError(error, "Cannot update Product",
        ));
    },
    removeProductCulture(product_id, cultures) {
      this.productCultures.id = product_id;

      if (Array.isArray(cultures)) {
        cultures.forEach(culture => {
          this.productCultures.culture_ids = this.productCultures.culture_ids.filter(id => id !== culture.id);
        });
      } else if (cultures && typeof cultures.id !== 'undefined') {
        this.productCultures.culture_ids = this.productCultures.culture_ids.filter(id => id !== cultures.id);
      }

      this.$emit('remove-culture', cultures);
    },
  },
  watch: {
    isModalOpen(newVal) {
      if (!newVal) {
        this.clearProductData();
      }
    }
  }
}
</script>